import styled from "styled-components";

export const ContactUsBannerWrapper = styled.div`
  padding: 95px 20px 0;
  @media (max-width: 1199px) {
    padding: 90px 0 0;
  }
  @media (max-width: 899px) {
    padding: 85px 0 0;
  }
  @media (max-width: 599px) {
    padding: 75px 0 0;
  }
  .contact_inner_Data {
    position: relative;
    border-radius: 25px;
    overflow: hidden;
    padding: 73px 0;
    @media (max-width: 1199px) {
      border-radius: 0;
      padding: 55px 0;
    }
    @media (max-width: 899px) {
      padding: 40px 0;
    }
    @media (max-width: 599px) {
      padding: 30px 0;
    }
    .contact_bg_img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .contact_row {
      margin: -31px;
      position: relative;
      z-index: 2;
      @media (max-width: 1199px) {
        margin: -20px;
      }
      @media (max-width: 899px) {
        margin: -10px;
      }
      .cmn_contact_col {
        padding: 31px;
        position: relative;
        z-index: 2;
        @media (max-width: 1199px) {
          padding: 20px;
        }
        @media (max-width: 899px) {
          padding: 10px;
        }
        &.col_left {
          max-width: 44.19%;
          width: 100%;
          border-radius: 25px;
          overflow: hidden;
          @media (max-width: 1199px) {
            max-width: 100%;
            border-radius: 12px;
          }
          &::before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 1;
            background: linear-gradient(
              89.57deg,
              rgba(0, 0, 0, 0.6) 37.24%,
              rgba(0, 0, 0, 0) 103.27%
            );
          }
          .col_left_inner {
            position: relative;
            z-index: 2;
            * {
              color: rgb(255, 255, 255);
            }
            h1 {
              max-width: 80%;
              font-size: 32px;
              @media (max-width: 1199px) {
                max-width: 100%;
                font-size: 30px;
              }
              @media (max-width: 899px) {
                font-size: 23px;
              }
            }
            .contact_sub_heading {
              margin: 15px 0;
              font-weight: 400;
              font-size: 20px;
            }
            .descriptionText {
              font-weight: 300;
              font-size: 12px;
            }
            .listBox {
              background: rgba(217, 217, 217, 0.2);
              border: 1px solid rgb(255, 255, 255);
              box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
              backdrop-filter: blur(5.8px);
              border-radius: 25px;
              padding: 19px 20px;
              margin-top: 35px;
              @media (max-width: 1199px) {
                border-radius: 15px;
                margin-top: 20px;
              }
              @media (max-width: 899px) {
                border-radius: 12px;
                padding: 20px 15px;
              }
              li {
                display: block;
                font-weight: 300;
                font-size: 12px;
                list-style: disc;
                position: relative;
                padding-left: 10px;
                &::before {
                  content: "";
                  position: absolute;
                  top: 7px;
                  left: 0;
                  width: 3px;
                  height: 3px;
                  border-radius: 50%;
                  background: rgba(256, 256, 256, 1);
                }
                span {
                  font-weight: 600;
                }
                &:not(:last-child) {
                  margin-bottom: 23px;
                  @media (max-width: 899px) {
                    margin-bottom: 12px;
                  }
                }
              }
            }
          }
        }
        &.col_righ {
          max-width: calc(100% - 44.19%);
          width: 100%;
          @media (max-width: 1199px) {
            max-width: 100%;
          }
          .right_inner_from {
            max-width: 610px;
            margin-left: auto;
            @media (max-width: 1199px) {
              max-width: 100%;
            }
            .from_Row {
              margin: -10px;
              @media (max-width: 899px) {
                margin: -7px;
              }
              .from_Col {
                padding: 10px;
                @media (max-width: 899px) {
                  padding: 7px;
                }
                @media (max-width: 599px) {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }
  }
`;
